<template>
  <div>
    <!-- <van-nav-bar
      title="隐私设置"
      left-arrow
      fixed
      placeholder
      @click-left="onClickLeft">
    </van-nav-bar> -->
    <div class="status" @click="shieldCompanies">
      <p>屏蔽公司</p>
      <span>已屏蔽公司{{blackList.length}}个</span>
    </div>
    <div class="tips">
      注：您可在企业列表中搜索您想屏蔽的公司，在企业详情中将该企业屏蔽。
    </div>
  </div>
</template>

<script>
export default {
  name: 'recommendedSetting',
  data() {
    return {
      companyNum:'',
      blackList:[]
    }
  },
  mounted(){
     this.$nextTick(() => {
       this.onload();
     })
  },
  methods: {
    onload(){
      this.module.api.blackEntList({
        data:{
          current: 1,
          size:10
        },
        success:({records}) => {
          this.blackList = records;
        }
      })
    },
    shieldCompanies() {
      this.$router.push({ name: 'shieldCompanies'})
    },
    onClickLeft() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less" scoped>
  .status{
    display: flex;
    margin:16px;
    padding: 16px 0;
    justify-content: space-between;
    align-items: center;
    position: relative;
    border-bottom: 1px solid #eee;
    p{
      font-size: 14px;
      color:#515255;
    }
    span{
      font-size: 10px;
      color:#BFC1C6;
      padding-right: 20px;
    }
    &:after{
      content: '\e603';
      font-family: van-icon;
      font-size: 14px;
      position: absolute;
      right:0;
      top:50%;
      transform: translate(0,-50%);
      color:#A3A7AD
    }
  }
  .tips{
    font-size: 12px;
    color:#606060;
    margin:20px;
    opacity: .8;
    line-height: 1.8;
  }
  .van-action-sheet{
    min-height: auto;
  }

</style>
